import clsx from "clsx";
import { Box, Button, CircularProgress, Tooltip } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { MyTextField } from "../../../../../components/custom/MyTextField";
import { Delete, FileCopy } from "@material-ui/icons";
import { Form, Formik } from "formik";
import useLogoForm from "./useLogoForm";

function LogoForm() {
  const {
    classes,
    intl,
    fileName,
    fileRef,
    handleSelectFile,
    initialValues,
    deleteFile,
    submit,
    contractingOffice,
    file,
    validationSchema,
    formatError,
  } = useLogoForm();

  return (
    <Box paddingLeft={"2rem"}>
      <Box className={classes.title}>
        <FormattedMessage id="logo" />*
      </Box>
      {contractingOffice?.logoUrl && (
        <Box marginY={"0.3rem"}>
          <Box display={"flex"}>
            <span>{intl.formatMessage({ id: "logoUrl" })}:</span>
            <a
              className="ml-02"
              href={contractingOffice?.logoUrl}
              target="_blank"
              rel="noreferrer"
            >
              <span className="overflow-wrap-anywhere">
                {intl.formatMessage({ id: "clickHere" })}
              </span>
            </a>
          </Box>
        </Box>
      )}
      <Formik
        validateOnChange={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (value, { resetForm }) => {
          await submit();
          resetForm();
        }}
      >
        {({ isSubmitting, handleChange, errors, resetForm }) => (
          <Form>
            <Box display={"flex"} alignItems={"start"} paddingTop={"0.1rem"}>
              <Box width={"100%"}>
                <input
                  name="fileName"
                  className="d-none"
                  ref={fileRef}
                  type="file"
                  onChange={(e) => {
                    handleSelectFile(e);
                    handleChange(e);
                  }}
                  accept=".png"
                  id="icon-button-file"
                />

                <MyTextField
                  disabled={true}
                  variant="outlined"
                  label={fileName}
                  value={fileName}
                  name="file"
                  className={classes.myTextFieldRoot}
                />
                <span className="field-error">
                  {errors.fileName ??
                    (formatError === true
                      ? intl.formatMessage({ id: "acceptedFormats" })
                      : "")}
                </span>
              </Box>
              <Tooltip
                title={`${intl.formatMessage({ id: "SearchDocument" })}`}
              >
                <label htmlFor="icon-button-file">
                  <Box marginTop={"0.5rem"}>
                    <Button
                      className={clsx(classes.btnAction, classes.save)}
                      component="span"
                    >
                      <FileCopy /> <FormattedMessage id="Attach" />
                    </Button>
                  </Box>
                </label>
              </Tooltip>
            </Box>
            {fileName && (
              <Box
                marginTop={"1rem"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <span>{file?.name}</span>
                <Button
                  onClick={() => {
                    resetForm();
                    deleteFile();
                  }}
                >
                  <Delete className="pointer ml-02" />
                </Button>
              </Box>
            )}
            <Box mt={5} display="flex" justifyContent={"center"}>
              <Button
                className={clsx(classes.btn, classes.save)}
                autoFocus
                type={"submit"}
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <CircularProgress className={classes.btnLoading} />
                ) : (
                  <FormattedMessage id="Save" />
                )}
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
export default LogoForm;
